/**
 * Reconcile a Razorpay order after the JS handler may not have fired (common with QR / UPI).
 * Polls the backend reconcile endpoint a few times before giving up.
 *
 * @param {string} kind - "subscription" or "addon"
 * @param {string} orderId - the Razorpay order_id
 * @param {{maxAttempts?: number, intervalMs?: number}} opts
 * @returns {Promise<{ok: boolean, alreadyApplied?: boolean}>}
 */
import api from "./api";

export async function reconcileRazorpayOrder(kind, orderId, opts = {}) {
  const path = kind === "addon"
    ? "/billing/addon/reconcile-order"
    : "/billing/subscription/reconcile-order";
  const max = opts.maxAttempts ?? 6;
  const interval = opts.intervalMs ?? 2500;
  for (let i = 0; i < max; i++) {
    try {
      const { data } = await api.post(path, { razorpay_order_id: orderId });
      if (data?.ok) return { ok: true, alreadyApplied: !!data.already_applied };
    } catch {
      // 404 (txn not found) → no point retrying
      return { ok: false };
    }
    if (i < max - 1) await new Promise((r) => setTimeout(r, interval));
  }
  return { ok: false };
}
